import { CreateParams, DataProvider, GetListParams, GetListResult, UpdateParams } from 'react-admin';
import { customReasonsProxy } from './apiGateway';

interface CustomReason {
    id: string;
    label: string;
    value: string;
    group: 'ads' | 'expert' | 'reviews';
    reasonType: 'refusal' | 'rework';
    createdAt?: string;
    updatedAt?: string;
}

interface CustomReasonsResponse {
    data: CustomReason[];
}

interface CustomReasonResponse {
    data: CustomReason;
}

export const customReasonsDataProvider = {
    getList: async (resource: string, params: GetListParams): Promise<GetListResult<CustomReason>> => {
        const json: CustomReasonsResponse = await customReasonsProxy.getList();
        const data = json.data || [];

        return {
            data,
            total: data.length
        };
    },
    create: async (resource: string, params: CreateParams<CustomReason>) => {
        const json: CustomReasonResponse = await customReasonsProxy.create({
            label: params.data.label ?? '',
            value: params.data.value ?? '',
            group: params.data.group ?? 'ads',
            reasonType: params.data.reasonType ?? 'rework'
        });
        return { data: json.data };
    },
    update: async (resource: string, params: UpdateParams<CustomReason>) => {
        const json: CustomReasonResponse = await customReasonsProxy.update(String(params.id), {
            label: params.data.label ?? '',
            value: params.data.value ?? '',
            group: params.data.group ?? 'ads',
            reasonType: params.data.reasonType ?? 'rework'
        });
        return { data: json.data };
    },
    delete: async (resource: string, params: { id: string }) => {
        const json: CustomReasonResponse = await customReasonsProxy.delete(String(params.id));
        return { data: json.data };
    }
} as DataProvider;
